import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Dropdown from "../Buttons/Dropdown";
import OrderAPI from "../../lib/API/OrderAPI";
import Currencies from "../../lib/Currencies";

const OrderStatus = {
    WAITING : 'WAITING',
    CANCELED : 'CANCELED',
    DELIVERED : 'DELIVERED',
    PROCESSING : 'PROCESSING',
}

const Orders = () => {

    const [state, setState] = useState({
        orders : null,
        reachedEnd : false,
        page : 0
    })

    useEffect(() => {
        loadOrders()
    }, [])

    const loadOrders = () => {
        OrderAPI.GetMyOrders(state.page+1)
        .then(({ data }) => {
                setState({
                    orders : (state.orders || []).concat(data),
                    page : state.page+1,
                    reachedEnd : data.length == 0
                });
            })
            .catch(() => alert('An error occured, try to refresh'));
    }

    const pay = (orderId) => {
        OrderAPI.PayOrder(orderId)
            .then(({ data : link }) => {
                window.location.href=link
            })
    }
    
    const cancel = (orderId) => {
        OrderAPI.CancelOrder(orderId)
            .then(() => {
                const order = state.orders.find(o => o.id == orderId);
                if(!order) return;
                order.status = OrderStatus.CANCELED;
                setState({
                    ...state,
                    orders : [...state.orders]
                });
            })
    }

    return (
        <>
            <div className="products-search ">
                <h3>My Orders</h3>
            </div>

            {state.orders && <div className="cart ">
                <div className="container row">
                    <div className="col">
                        <table className="orders-table items w-100">
                            <thead>
                                <tr>
                                    <td>Items</td>
                                    <td style={{ width : "10%" }} className="text-center">Date</td>
                                    <td>Quantity</td>
                                    <td style={{ width : "12%" }} >Total Price</td>
                                    <td className="actions" style={{ width : "10%" }} >Status</td>
                                    <td style={{ width : "192px" }} ></td>
                                </tr>
                            </thead>
                            <tbody>
                                {state.orders.map((order) => (
                                    <tr key={order.id} className="order-row">
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <h6 style={{ flex: 1 }}><Link to={'/orders/' + order.id}>{order.label}</Link></h6>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <h6 style={{ flex: 1 }}>{moment(order.date).format('MMM DD')}</h6>
                                        </td>
                                        <td>
                                            <p>{order.items.length} items</p>
                                        </td>
                                        <td>
                                            <p>{order.amount.toFixed(4)} {order.token}</p>
                                        </td>
                                        <td>
                                            {order.status == OrderStatus.DELIVERED && (
                                                <p>Delivered</p>
                                            )}
                                            {order.status == OrderStatus.WAITING && (
                                                <p>Waiting Payment</p>
                                            )}
                                            {order.status == OrderStatus.PROCESSING && (
                                                <p>PROCESSING</p>
                                            )}
                                            {order.status == OrderStatus.CANCELED && (
                                                <p>Canceled</p>
                                            )}
                                        </td>
                                        <td>
                                            {order.status == OrderStatus.WAITING && (
                                                <Dropdown label={"Actions"}>
                                                    <a className="dropdown-item" onClick={pay.bind(this, order.id)}>Pay</a>
                                                    <Link to={`/support?order=${order.id}&orderName=${order.label}`} className="dropdown-item">Report problem</Link>
                                                    <a className="dropdown-item" onClick={cancel.bind(this, order.id)}>Cancel</a>
                                                </Dropdown>
                                            )}
                                        </td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>

                    </div>
                    {!state.reachedEnd && (
                        <div className="row text-center">
                            <div className="col">
                                <button class="btn-black" onClick={loadOrders}>Load More</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>}
        </>
    )
}

export { Orders };